import {Component, Injector, OnInit, signal} from '@angular/core';
import {FlexModule} from "@angular/flex-layout";
import {BasePageComponent} from "@core-components/page-content/base-page.component";
import {AgreementType, OccupancyType} from "@features/leasing/leasing.model";
import {AppCoreModule} from "@modules/app.core.module";
import {ManageBookingComponent} from "./manage-booking/manage-booking.component";
import {RetailerLookupComponentOptions} from "@shared-components/retailer-lookup/retailer-lookup.model";
import {ApplicationAssessmentStatus, TenantType} from "../../leads/retailers/retailers.model";

@Component({
  selector: 'app-lease-bookings',
  standalone: true,
  imports: [
    AppCoreModule,
    FlexModule,
    ManageBookingComponent
  ],
  templateUrl: './lease-bookings.component.html',
  styleUrl: './lease-bookings.component.scss'
})
export class LeaseBookingsComponent extends BasePageComponent implements OnInit {

  retailerLookupOptions = signal<Partial<RetailerLookupComponentOptions>>({
    allowedRetailerTenantTypes : [TenantType.TENANT, TenantType.OFFERING],
    allowedCurationStatus: [ApplicationAssessmentStatus.APPROVED]
  });

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
  }

  protected readonly OccupancyType = OccupancyType;
  protected readonly AgreementType = AgreementType;
}
